import { SagisConfig } from 'containers/AppContainer/typings';
import { AssignedClaim } from 'containers/CourtManagerAssignedClaims/typings';
import { CLAIM } from 'containers/data-structure';
import { get, isEmpty } from 'lodash';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import {
  LAWYER_ASSIGNMENTS_LABELS,
  CLAIM_STATUS_TRANSLATE,
} from 'containers/LawyerAssignmentsPage/constants';

export const formatAssignedClaims = (
  assignedClaims: AssignedClaim[],
  cities: SagisConfig[],
) => {
  const assignedLawyers: any[] = [];
  if (isEmpty(assignedClaims)) return [];
  return assignedClaims.map(assignedClaim => {
    if (
      assignedLawyers.find(
        (el: any) =>
          el.assignedLawyer === assignedClaim.assignedLawyer &&
          el.claimId === assignedClaim.claimId,
      )
    )
      return null;
    assignedLawyers.push({
      assignedLawyer: assignedClaim.assignedLawyer,
      claimId: assignedClaim.claimId,
    });
    const { claim, existingClaim } = assignedClaim;

    if (get(existingClaim, 'id', '') || !claim) {
      return { ...assignedClaim };
    }

    const city = cities.find(
      (city: SagisConfig) => city.ItemKey === assignedClaim.claim?.lossLocation,
    );

    return {
      ...assignedClaim,
      claim: {
        ...assignedClaim.claim,
        [CLAIM.LOSS_LOCATION]: get(city, 'ItemDescription'),
      },
    };
  });
};

export const displayByProp = (prop: string, assignment: AssignedClaim) =>
  get(assignment.claim, `${prop}`) || get(assignment.existingClaim, `${prop}`);

export const displayStatus = (assignment: AssignedClaim) => {
  const status: string = get(assignment.claim, 'judgement[0].status', '');

  if (!status) {
    return CLAIM_STATUS_TRANSLATE.PROCES_VERBAL;
  }
  return CLAIM_STATUS_TRANSLATE[status];
};

export const displayMotif = (assignment: AssignedClaim) =>
  get(assignment.claim, 'judgement[0].rejectionReason');

export const setStep = (currentStep: number) => {
  if (
    featureService.hasFeature(FEATURES.LEGAL_PROCEEDING_STEP) &&
    currentStep
  ) {
    return LAWYER_ASSIGNMENTS_LABELS[currentStep];
  }

  return null;
};
